import { createSelector } from 'reselect';
import { name } from './config';
import { State } from './reducer';

type StatePiece = { [key in typeof name]: typeof State['prototype'] };

export const getUserData = (state: StatePiece) => state.user;

export const selectAuthorizedState = createSelector(getUserData, state => state.authorized);
